import { For, If } from 'cdui-js';
import { lastProcess, nextProcess, pState } from '../store';
import i18n from '../../../../../i18n';

export const PreparePage = () => {
  const list = [
    {
      title: i18n.OpenProgress.Offline.Prepare.StepWitnessTitle,
      desc: i18n.OpenProgress.Offline.Prepare.StepWitnessDesc,
    },
    {
      title: i18n.OpenProgress.Offline.Prepare.StepInfoTitle,
      desc: i18n.OpenProgress.Offline.Prepare.StepInfoDesc,
    },
    {
      title: i18n.OpenProgress.Offline.Prepare.StepRiskTitle,
      desc: '',
    },
  ];

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="color-D font-s-L" style={{ 'margin-bottom': '32px' }}>
        {i18n.OpenProgress.Offline.Prepare.OnlineTransferTitle}
      </div>
      <div>
        <For each={list}>
          {(item, index) => (
            <div class="flex padding-b-XL align-start">
              <If when={index() < 2}>
                <svg
                  style={{ position: 'relative', left: '11px', top: '24px', 'flex-shrink': 0 }}
                  width="1"
                  height="54"
                  viewBox="0 0 1 54"
                  stroke="none"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="0.5"
                    y1="0.5"
                    x2="0.499998"
                    y2="53"
                    style={{ stroke: 'var(--border-1)' }}
                    stroke-linecap="round"
                    stroke-dasharray="2 4"
                  />
                </svg>
              </If>

              <div
                class="color-D bg-c-XD flex align-center justify-center flex-shrink-0"
                style={{ 'border-radius': '50%', width: '20px', height: '20px', 'margin-top': '2px' }}
              >
                {index() + 1}
              </div>
              {/* border-l border-l-s-dashed  */}
              <div class="padding-l open-progress-step-content">
                <div class="color-D font-s margin-b-XS">{item.title}</div>
                <If when={item.desc}>
                  <div class="font-s-S open-progress-step-desc">{item.desc}</div>
                </If>
              </div>
            </div>
          )}
        </For>
      </div>

      <button
        class="button-round button-primary round-XXL"
        style={{ height: '50px', width: '100%', 'margin-top': '44px' }}
        onclick={() => nextProcess()}
      >
        {i18n.OpenProgress.Common.Next}
      </button>

      <div class="margin-t flex justify-center link-color" onclick={() => lastProcess()}>
        {i18n.OpenProgress.Offline.Prepare.OtherMethods}
      </div>
    </div>
  );
};
